import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=13e4dfb0&scoped=true"
import script from "./statistics.vue?vue&type=script&lang=js"
export * from "./statistics.vue?vue&type=script&lang=js"
import style0 from "./statistics.vue?vue&type=style&index=0&id=13e4dfb0&prod&lang=scss&scoped=true"
import style1 from "./statistics.vue?vue&type=style&index=1&id=13e4dfb0&prod&lang=scss"
import style2 from "./statistics.vue?vue&type=style&index=2&id=13e4dfb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e4dfb0",
  null
  
)

export default component.exports